import imagesLoaded from 'imagesloaded';

export default function (elements, _delay) {
    let delay = _delay;
    if (typeof delay === 'undefined') {
        delay = 0;
    }
    const run = () => {
        let currentTallest = 0;
        let currentRowStart = 0;
        const rowDivs = [];

        for (let item of elements) {
            item.style.height = "auto";
            const topPosition = item.getBoundingClientRect().top;
            let currentDiv;

            if (currentRowStart !== topPosition) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
                    rowDivs[currentDiv].style.height = currentTallest + "px";
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPosition;
                currentTallest = item.clientHeight;
                rowDivs.push(item);
            } else {
                rowDivs.push(item);
                currentTallest = (currentTallest < item.clientHeight) ?
                    (item.clientHeight) :
                    (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
                rowDivs[currentDiv].style.height = currentTallest + "px";
            }
        }
    };

    setTimeout(() => {
        run();
    }, delay);
    window.onresize = () => run();
    imagesLoaded( elements, () => {
        run();
    });
}



// WEBPACK FOOTER //
// ./src/functions/equalHeight.js